import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "../static/css/menuProducto.css";
import { useAuth } from "../AuthContext";

export default function MenuProducto() {
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate("/");
        return;
    };

    return (
        <Navbar expand="lg" className="menu-navbar shadow-sm" variant="dark">
            <Container fluid>
                <Navbar.Brand
                    className="fw-bold brand"
                    style={{ cursor: "pointer" }}
                    onClick={handleLogoClick}
                >
                    💅 Retornar al Menú
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="menu-navbar-nav" />
                <Navbar.Collapse id="menu-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="bodegas" className="menu-link">
                            Mis Bodegas
                        </Nav.Link>
                        <Nav.Link as={Link} to="categorias" className="menu-link">
                            Categorías
                        </Nav.Link>
                        <Nav.Link as={Link} to="/productos" className="menu-link">
                            Ver Productos
                        </Nav.Link>
                        <Nav.Link as={Link} to="agregar" className="menu-link">
                            Agregar Producto
                        </Nav.Link>
                        <Nav.Link as={Link} to="pos" className="menu-link">
                            Punto de Venta
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}